import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface SpaceGroupListingCardProps {
  resources: Array<{ name: string; id: string }>;
}

export const SpaceGroupListingCard = ({
  resources,
}: SpaceGroupListingCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.space_groups")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_space_groups_found")}
    renderItem={space_group => space_group.name}
    getItemKey={space_group => space_group.id}
  />
);
